import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ReturningStep1 } from '../components/Returning/ReturningStep1/ReturningStep1'
import { ReturningStep2 } from '../components/Returning/ReturningStep2/ReturningStep2'
import { ReturningStep3 } from '../components/Returning/ReturningStep3/ReturningStep3'
import { TransactionFlowPage } from '../components/Transaction/TransactionFlowPage'
import { useReturningFormContext } from '../context/returningContext'
import { withErrorBoundary } from '../components/hoc/withErrorBoundary'
import { mapKlantTransactieToReturningFormValues } from '../utils/returningMapper'

const Returning = () => {
  return (
    <TransactionFlowPage
      search={Route.useSearch()}
      i18nPrefix='returning'
      editTitleKey='returning.editReturning'
      createTitleKey='returning.newReturning'
      useFormContext={useReturningFormContext}
      mapTransactionToFormValues={mapKlantTransactieToReturningFormValues}
      Step1Component={ReturningStep1}
      Step2Component={ReturningStep2}
      Step3Component={ReturningStep3}
    />
  )
}

export const Route = createFileRoute('/returning')({
  validateSearch: z.object({
    mode: z.enum(['create', 'edit']).catch('create'),
    transactionId: z.string().optional(),
  }),
  component: withErrorBoundary(Returning),
})
